import { fbcFromFbclidQueryParam, gclidFromQueryParam } from "@capi/types";
import { IActionRequestTrackingInfo } from "@forms/schema";

export function getActionTrackingInfo(
  cookies: {
    _fbp?: unknown;
    _fbc?: unknown;
    gclid?: unknown;
    test_event_code?: unknown;
    ttclid?: unknown;
    _ttp?: unknown;
  },
): IActionRequestTrackingInfo {
  return {
    fbp: cookies._fbp?.toString(),
    fbc: fbcFromFbclidQueryParam(window.location.href, console.error)?.fbc || cookies._fbc?.toString(),
    gclid: gclidFromQueryParam(globalThis.window.location.href, console.error)?.gclid || cookies.gclid?.toString(),
    test_event_code: cookies.test_event_code?.toString(),
    ttclid: cookies.ttclid?.toString(),
    _ttp: cookies._ttp?.toString(),
    pageUrl: window.location.href,
  };
}
